/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetReportTab200ResponseReservation
 */
export interface GetReportTab200ResponseReservation {
    /**
     * 
     * @type {number}
     * @memberof GetReportTab200ResponseReservation
     */
    diners: number;
    /**
     * 
     * @type {Date}
     * @memberof GetReportTab200ResponseReservation
     */
    dateTime: Date;
    /**
     * 
     * @type {string}
     * @memberof GetReportTab200ResponseReservation
     */
    zone: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetReportTab200ResponseReservation
     */
    tables: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetReportTab200ResponseReservation
     */
    source: string;
    /**
     * 
     * @type {string}
     * @memberof GetReportTab200ResponseReservation
     */
    comments?: string;
}

/**
 * Check if a given object implements the GetReportTab200ResponseReservation interface.
 */
export function instanceOfGetReportTab200ResponseReservation(value: object): value is GetReportTab200ResponseReservation {
    if (!('diners' in value) || value['diners'] === undefined) return false;
    if (!('dateTime' in value) || value['dateTime'] === undefined) return false;
    if (!('zone' in value) || value['zone'] === undefined) return false;
    if (!('tables' in value) || value['tables'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    return true;
}

export function GetReportTab200ResponseReservationFromJSON(json: any): GetReportTab200ResponseReservation {
    return GetReportTab200ResponseReservationFromJSONTyped(json, false);
}

export function GetReportTab200ResponseReservationFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReportTab200ResponseReservation {
    if (json == null) {
        return json;
    }
    return {
        
        'diners': json['diners'],
        'dateTime': (new Date(json['dateTime'])),
        'zone': json['zone'],
        'tables': json['tables'],
        'source': json['source'],
        'comments': json['comments'] == null ? undefined : json['comments'],
    };
}

export function GetReportTab200ResponseReservationToJSON(json: any): GetReportTab200ResponseReservation {
    return GetReportTab200ResponseReservationToJSONTyped(json, false);
}

export function GetReportTab200ResponseReservationToJSONTyped(value?: GetReportTab200ResponseReservation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'diners': value['diners'],
        'dateTime': ((value['dateTime']).toISOString()),
        'zone': value['zone'],
        'tables': value['tables'],
        'source': value['source'],
        'comments': value['comments'],
    };
}

